import { Heading, theme } from '@hhgtech/hhg-components'
import { Category } from 'interfaces/types'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'

import { DEFAULT_RESULT_IMG } from '../../../interfaces/constants'
import {
  StyledRelatedCategoriesList,
  StyledRelatedCategoriesContainer,
  StyledCategoryCard,
  StyledSeeMoreButton,
} from './index.styled'

export type Props = {
  size?: 'lg' | 'md' | 'sm'
  className?: string
  currentCategoryPermalink?: string
  categories: Array<Category>
  title?: string
  isMobile?: boolean
}

const RelatedCategoriesList = ({
  className,
  title,
  // size = 'md',
  categories = [],
  currentCategoryPermalink = '#',
  isMobile,
}: Props) => {
  const router = useRouter()
  const { formatMessage: f } = useIntl()
  return (
    <StyledRelatedCategoriesList className={className}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1rem',
        }}
      >
        <Heading tag={isMobile ? 'h3' : 'h4'} color="#262626">
          {title || f({ id: 'articlePage.relatedCategoriesListSectionTitle' })}
        </Heading>
        {categories.length > 3 && (
          <StyledSeeMoreButton
            size="lg"
            color="ghost"
            onClick={() => router.push(currentCategoryPermalink)}
          >
            <Heading
              style={{ display: 'flex' }}
              tag="h5"
              color={theme.colors.primaryBase}
            >
              {f({ id: 'articlePage.seeMore' })}
              <img
                loading="lazy"
                src={'/images/chevronRightBlue.svg'}
                style={{ width: '16px', height: '16px' }}
                alt="See more"
              />
            </Heading>
          </StyledSeeMoreButton>
        )}
      </div>
      <StyledRelatedCategoriesContainer>
        {categories.slice(0, 3).map((category, index) => (
          <StyledCategoryCard
            category={category}
            key={index}
            href={category.permalink}
            imgBanner={
              <img
                loading="lazy"
                style={{ objectFit: 'contain' }}
                src={category.featureImage || DEFAULT_RESULT_IMG}
                alt={category.categoryName || ''}
              />
            }
            // label={article.label}
            label={category.categoryName || ''}
            className={
              index + 1 === categories.length ? 'last-category-card' : ''
            }
          />
        ))}
      </StyledRelatedCategoriesContainer>
    </StyledRelatedCategoriesList>
  )
}

export { RelatedCategoriesList }
